/**
 * Excel Filters Early Buy — fixture-backed storefront review shell (EB-16).
 * Client-side pricing is for owner review only; production submits go through
 * the signed app proxy (server-authoritative Neon matrix).
 */
(function () {
  "use strict";

  var QTY_MAX = 9999;
  var ROOT = document.getElementById("eb-order-form-root");
  if (!ROOT) return;

  var state = {
    catalog: null,
    qty: Object.create(null),
    search: "",
    step: "products", // products | details | shipments | confirm
    customer: {
      companyName: "",
      contactName: "",
      businessEmail: "",
      phone: "",
      poNumber: "",
      notes: "",
      directNotCarecraft: false,
      requestForReview: false,
    },
    windows: [],
    alloc: Object.create(null), // sku -> { windowCode: packs }
    formStartedAt: Date.now(),
    reference: null,
  };

  function money(cents) {
    return (cents / 100).toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  }

  function tierForRetail(retailCents, tiers) {
    for (var i = 0; i < tiers.length; i++) {
      var t = tiers[i];
      if (retailCents < t.min) continue;
      if (t.max == null || retailCents <= t.max) return t;
    }
    return null;
  }

  function basket() {
    var products = state.catalog.products;
    var retail = 0;
    var payable = 0;
    var lines = [];
    var tierGuess = null;
    // First pass retail
    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      var q = state.qty[p.sku] || 0;
      if (q <= 0) continue;
      retail += p.retailUnitCents * q;
      lines.push({ product: p, qty: q });
    }
    if (retail > 0) {
      tierGuess = tierForRetail(retail, state.catalog.tiers);
    }
    if (tierGuess) {
      for (var j = 0; j < lines.length; j++) {
        var line = lines[j];
        var unit =
          (line.product.prices &&
            line.product.prices.standard &&
            line.product.prices.standard[tierGuess.code]) ||
          Math.round(
            (line.product.retailUnitCents * (100 - tierGuess.discount)) / 100,
          );
        payable += unit * line.qty;
        line.unit = unit;
        line.retailLine = line.product.retailUnitCents * line.qty;
        line.payableLine = unit * line.qty;
      }
    }
    return {
      retail: retail,
      payable: payable,
      savings: Math.max(0, retail - payable),
      tier: tierGuess,
      lines: lines,
    };
  }

  function filteredProducts() {
    var q = state.search.trim().toLowerCase();
    var list = state.catalog.products;
    if (!q) return list;
    return list.filter(function (p) {
      return (
        p.sku.toLowerCase().indexOf(q) !== -1 ||
        (p.housing && p.housing.toLowerCase().indexOf(q) !== -1)
      );
    });
  }

  function setQty(sku, n) {
    n = Math.max(0, Math.min(QTY_MAX, Number(n) || 0));
    if (n === 0) delete state.qty[sku];
    else state.qty[sku] = n;
    render();
  }

  function ensureAlloc(sku, windows) {
    if (!state.alloc[sku]) state.alloc[sku] = Object.create(null);
    windows.forEach(function (w) {
      if (state.alloc[sku][w] == null) state.alloc[sku][w] = 0;
    });
    Object.keys(state.alloc[sku]).forEach(function (w) {
      if (windows.indexOf(w) === -1) delete state.alloc[sku][w];
    });
  }

  function unassigned(sku, qty) {
    var sum = 0;
    var map = state.alloc[sku] || {};
    Object.keys(map).forEach(function (w) {
      sum += Number(map[w]) || 0;
    });
    return qty - sum;
  }

  function esc(s) {
    return String(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function renderHeader() {
    return (
      '<header class="eb-header">' +
      '<p class="eb-brand">Excel Filters</p>' +
      '<h1 class="eb-brand" style="font-size:clamp(1.35rem,2.5vw,1.75rem)">2027 Early Buy proposal</h1>' +
      '<p class="eb-subhead">Build a bulk proposal for review. Qualifying value uses retail totals; estimated payable uses the flyer matrix. This is a <strong>request for review</strong> — not checkout or payment.</p>' +
      '<div class="eb-contact">' +
      '<a href="tel:+18885322801">(888) 532-2801</a>' +
      '<a href="mailto:ecommerce@edenequipment.com">ecommerce@edenequipment.com</a>' +
      "</div>" +
      '<div class="eb-callout" role="note"><strong>Carecraft:</strong> Early Buy is for direct Excel Filters orders only. Carecraft pricing is not available on this form.</div>' +
      '<div class="eb-callout" role="status"><strong>Review shell:</strong> Fixture catalog (' +
      state.catalog.skuCount +
      " SKUs). Live Neon/app-proxy submit activates after Partner API secret + app host.</div>" +
      "</header>" +
      '<div class="eb-hp" aria-hidden="true"><label for="website_url">Website</label><input id="website_url" name="website_url" tabindex="-1" autocomplete="off"></div>'
    );
  }

  function renderSummary(b) {
    var tierLabel = b.tier ? b.tier.label + " (" + b.tier.discount + "%)" : "—";
    var progress =
      b.retail < 100000
        ? money(100000 - b.retail) + " more retail to reach Splash"
        : b.tier
          ? "Tier: " + b.tier.label
          : "";
    return (
      '<aside class="eb-panel eb-summary">' +
      "<h2>Summary</h2>" +
      '<div class="eb-summary-block"><p class="eb-summary-label">Qualifying retail</p><p class="eb-summary-value">' +
      money(b.retail) +
      '</p><p class="eb-summary-secondary">' +
      esc(progress) +
      "</p></div>" +
      '<div class="eb-summary-block"><p class="eb-summary-label">Est. payable</p><p class="eb-summary-value">' +
      (b.tier ? money(b.payable) : "—") +
      '</p><p class="eb-summary-secondary">Est. savings ' +
      (b.tier ? money(b.savings) : "—") +
      "</p></div>" +
      '<div class="eb-summary-block"><p class="eb-summary-label">Tier</p><p class="eb-summary-value">' +
      esc(tierLabel) +
      "</p></div>" +
      '<div class="eb-summary-block"><p class="eb-summary-label">Lines</p><p class="eb-summary-value">' +
      b.lines.length +
      "</p></div>" +
      "</aside>"
    );
  }

  function renderProducts(b) {
    var items = filteredProducts()
      .map(function (p) {
        var q = state.qty[p.sku] || 0;
        return (
          '<li class="eb-product" data-sku="' +
          esc(p.sku) +
          '">' +
          '<div class="eb-product-meta"><div class="eb-product-sku">' +
          esc(p.sku) +
          '</div><div class="eb-product-name">' +
          esc(p.housing || "") +
          '</div><div class="eb-product-retail">Retail ' +
          money(p.retailUnitCents) +
          "</div></div>" +
          '<div class="eb-qty">' +
          '<button type="button" data-act="dec" aria-label="Decrease">−</button>' +
          '<input type="number" min="0" max="' +
          QTY_MAX +
          '" value="' +
          q +
          '" data-act="qty">' +
          '<button type="button" data-act="inc" aria-label="Increase">+</button>' +
          "</div></li>"
        );
      })
      .join("");
    return (
      '<div class="eb-panel"><h2>Products</h2>' +
      '<input class="eb-search" type="search" placeholder="Search SKU or housing…" value="' +
      esc(state.search) +
      '" data-act="search">' +
      '<ul class="eb-product-list">' +
      items +
      "</ul>" +
      '<div class="eb-btn-row"><button type="button" class="eb-btn eb-btn-primary" data-act="to-details"' +
      (b.retail < 100000 ? " disabled" : "") +
      ">Continue to customer details</button></div>" +
      '<p class="eb-footnote">Minimum qualifying retail: $1,000. Pack quantities 0–9999.</p></div>'
    );
  }

  function renderDetails() {
    var c = state.customer;
    return (
      '<div class="eb-panel"><h2>Customer details</h2>' +
      '<p class="eb-footnote">Required for review. This submits a request for review — not a checkout or payment.</p>' +
      '<div class="eb-grid-2">' +
      field("companyName", "Company", c.companyName) +
      field("contactName", "Contact name", c.contactName) +
      field("businessEmail", "Business email", c.businessEmail, "email") +
      field("phone", "Phone", c.phone, "tel") +
      "</div>" +
      field("poNumber", "PO number (optional)", c.poNumber) +
      '<div class="eb-field"><label for="eb-notes">Notes (optional)</label><textarea id="eb-notes" rows="3" data-field="notes">' +
      esc(c.notes) +
      "</textarea></div>" +
      '<label class="eb-check"><input type="checkbox" data-field="directNotCarecraft"' +
      (c.directNotCarecraft ? " checked" : "") +
      '> I confirm this is a <strong>direct order with Excel Filters</strong> and is not Carecraft pricing or a Carecraft order.</label>' +
      '<label class="eb-check"><input type="checkbox" data-field="requestForReview"' +
      (c.requestForReview ? " checked" : "") +
      '> I understand this is a <strong>request for review</strong> — not an order confirmation and not a payment request.</label>' +
      '<div class="eb-btn-row">' +
      '<button type="button" class="eb-btn eb-btn-secondary" data-act="to-products">Back</button>' +
      '<button type="button" class="eb-btn eb-btn-primary" data-act="to-shipments">Continue to shipments</button>' +
      "</div></div>"
    );
  }

  function field(key, label, value, type) {
    return (
      '<div class="eb-field"><label for="eb-' +
      key +
      '">' +
      esc(label) +
      '</label><input id="eb-' +
      key +
      '" type="' +
      (type || "text") +
      '" data-field="' +
      key +
      '" value="' +
      esc(value) +
      '"></div>'
    );
  }

  function renderShipments(b) {
    if (!b.tier) {
      return (
        '<div class="eb-panel"><p class="eb-error">Add products to reach a tier first.</p>' +
        '<button type="button" class="eb-btn eb-btn-secondary" data-act="to-products">Back</button></div>'
      );
    }
    var allowance = b.tier.allowance;
    var chips = state.catalog.windows
      .map(function (w) {
        var on = state.windows.indexOf(w.code) !== -1;
        return (
          '<button type="button" class="eb-chip" data-act="toggle-window" data-code="' +
          esc(w.code) +
          '" aria-pressed="' +
          (on ? "true" : "false") +
          '">' +
          esc(w.label) +
          "</button>"
        );
      })
      .join("");

    state.windows.forEach(function () {});
    b.lines.forEach(function (line) {
      ensureAlloc(line.product.sku, state.windows);
    });

    var head =
      "<tr><th>SKU</th>" +
      state.windows
        .map(function (code) {
          var w = state.catalog.windows.find(function (x) {
            return x.code === code;
          });
          return "<th>" + esc(w ? w.label : code) + "</th>";
        })
        .join("") +
      "<th>Unassigned</th></tr>";

    var body = b.lines
      .map(function (line) {
        var sku = line.product.sku;
        var cells = state.windows
          .map(function (code) {
            var v = (state.alloc[sku] && state.alloc[sku][code]) || 0;
            return (
              '<td><input type="number" min="0" max="' +
              line.qty +
              '" value="' +
              v +
              '" data-act="alloc" data-sku="' +
              esc(sku) +
              '" data-window="' +
              esc(code) +
              '"></td>'
            );
          })
          .join("");
        var u = unassigned(sku, line.qty);
        var cls =
          "eb-unassigned " + (u === 0 ? "is-zero" : u < 0 ? "is-bad" : "is-bad");
        return (
          "<tr><td>" +
          esc(sku) +
          " ×" +
          line.qty +
          "</td>" +
          cells +
          '<td class="' +
          cls +
          '">' +
          u +
          "</td></tr>"
        );
      })
      .join("");

    var canSubmit =
      state.windows.length >= 1 &&
      state.windows.length <= allowance &&
      b.lines.every(function (line) {
        return unassigned(line.product.sku, line.qty) === 0;
      });

    return (
      '<div class="eb-panel"><h2>Shipment planner</h2>' +
      "<p>Select 1–" +
      allowance +
      " window(s) for " +
      esc(b.tier.label) +
      ". Allocate every pack exactly.</p>" +
      '<div class="eb-windows">' +
      chips +
      "</div>" +
      '<div class="eb-matrix-wrap"><table class="eb-matrix"><thead>' +
      head +
      "</thead><tbody>" +
      body +
      "</tbody></table></div>" +
      '<p class="eb-footnote">Free standard shipping within the continental United States. Excludes liftgate, restricted-access, and other custom delivery methods.</p>' +
      '<div class="eb-btn-row">' +
      '<button type="button" class="eb-btn eb-btn-secondary" data-act="to-details">Back</button>' +
      '<button type="button" class="eb-btn eb-btn-primary" data-act="submit"' +
      (canSubmit ? "" : " disabled") +
      ">Submit request for review</button>" +
      "</div></div>"
    );
  }

  function renderConfirm(b) {
    return (
      '<div class="eb-confirm"><h2>Proposal received for review</h2>' +
      '<p class="eb-ref">' +
      esc(state.reference) +
      "</p>" +
      "<p>Thank you. This is a <strong>request for review</strong> — not an order confirmation and not a payment due notice.</p>" +
      "<dl>" +
      "<dt>Tier</dt><dd>" +
      esc(b.tier ? b.tier.label : "—") +
      "</dd>" +
      "<dt>Qualifying retail</dt><dd>" +
      money(b.retail) +
      "</dd>" +
      "<dt>Est. payable</dt><dd>" +
      money(b.payable) +
      "</dd>" +
      "<dt>Company</dt><dd>" +
      esc(state.customer.companyName) +
      "</dd>" +
      "</dl>" +
      '<p class="eb-footnote">Our team will follow up at ' +
      esc(state.customer.businessEmail) +
      " or (888) 532-2801.</p>" +
      '<div class="eb-btn-row"><button type="button" class="eb-btn eb-btn-secondary" data-act="reset">Start another proposal</button></div></div>'
    );
  }

  function render() {
    if (!state.catalog) {
      ROOT.innerHTML =
        '<div class="eb-shell"><p class="eb-panel">Loading Early Buy catalog…</p></div>';
      return;
    }
    var b = basket();
    var main = "";
    if (state.step === "products") main = renderProducts(b);
    else if (state.step === "details") main = renderDetails();
    else if (state.step === "shipments") main = renderShipments(b);
    else if (state.step === "confirm") main = renderConfirm(b);

    ROOT.innerHTML =
      '<div class="eb-shell">' +
      renderHeader() +
      (state.step === "confirm"
        ? main
        : '<div class="eb-layout"><div>' +
          main +
          "</div>" +
          renderSummary(b) +
          "</div>") +
      "</div>";
  }

  function validateDetails() {
    var c = state.customer;
    var errs = [];
    if (!c.companyName.trim()) errs.push("Company is required");
    if (!c.contactName.trim()) errs.push("Contact name is required");
    if (!c.businessEmail.trim()) errs.push("Business email is required");
    if (!c.phone.trim()) errs.push("Phone is required");
    if (!c.directNotCarecraft) errs.push("Carecraft / direct-order acknowledgment is required");
    if (!c.requestForReview) errs.push("Request-for-review acknowledgment is required");
    return errs;
  }

  function onClick(e) {
    var t = e.target.closest("[data-act]");
    if (!t) return;
    var act = t.getAttribute("data-act");
    var product = t.closest(".eb-product");
    var sku = product && product.getAttribute("data-sku");

    if (act === "inc" && sku) setQty(sku, (state.qty[sku] || 0) + 1);
    else if (act === "dec" && sku) setQty(sku, (state.qty[sku] || 0) - 1);
    else if (act === "to-details") {
      if (basket().retail < 100000) return;
      state.step = "details";
      render();
    } else if (act === "to-products") {
      state.step = "products";
      render();
    } else if (act === "to-shipments") {
      var errs = validateDetails();
      if (errs.length) {
        alert(errs.join("\n"));
        return;
      }
      var b = basket();
      state.windows = state.windows.slice(0, b.tier ? b.tier.allowance : 1);
      if (!state.windows.length && state.catalog.windows[0]) {
        state.windows = [state.catalog.windows[0].code];
      }
      state.step = "shipments";
      render();
    } else if (act === "toggle-window") {
      var code = t.getAttribute("data-code");
      var b2 = basket();
      var max = b2.tier ? b2.tier.allowance : 1;
      var idx = state.windows.indexOf(code);
      if (idx >= 0) state.windows.splice(idx, 1);
      else if (state.windows.length < max) state.windows.push(code);
      render();
    } else if (act === "submit") {
      var hp = document.getElementById("website_url");
      if (hp && hp.value) return;
      if (Date.now() - state.formStartedAt < 2000) {
        alert("Please take a moment to review before submitting.");
        return;
      }
      state.reference =
        "EB27-REVIEW-" + String(Math.floor(Math.random() * 900000) + 100000);
      state.step = "confirm";
      render();
      window.scrollTo(0, 0);
    } else if (act === "reset") {
      state.qty = Object.create(null);
      state.alloc = Object.create(null);
      state.windows = [];
      state.step = "products";
      state.reference = null;
      state.formStartedAt = Date.now();
      render();
    }
  }

  function onInput(e) {
    var t = e.target;
    if (t.getAttribute("data-act") === "search") {
      state.search = t.value;
      render();
      var search = ROOT.querySelector("[data-act=search]");
      if (search) {
        search.focus();
        var len = search.value.length;
        search.setSelectionRange(len, len);
      }
      return;
    }
    if (t.getAttribute("data-act") === "qty") {
      var product = t.closest(".eb-product");
      if (product) setQty(product.getAttribute("data-sku"), t.value);
      return;
    }
    if (t.getAttribute("data-act") === "alloc") {
      var sku = t.getAttribute("data-sku");
      var w = t.getAttribute("data-window");
      if (!state.alloc[sku]) state.alloc[sku] = Object.create(null);
      state.alloc[sku][w] = Math.max(0, Number(t.value) || 0);
      render();
      return;
    }
    var field = t.getAttribute("data-field");
    if (field) {
      if (t.type === "checkbox") state.customer[field] = t.checked;
      else state.customer[field] = t.value;
    }
  }

  ROOT.addEventListener("click", onClick);
  ROOT.addEventListener("input", onInput);
  ROOT.addEventListener("change", onInput);

  fetch(ROOT.getAttribute("data-fixture-url"), { credentials: "same-origin" })
    .then(function (r) {
      if (!r.ok) throw new Error("fixture " + r.status);
      return r.json();
    })
    .then(function (data) {
      state.catalog = data;
      render();
    })
    .catch(function (err) {
      ROOT.innerHTML =
        '<div class="eb-shell"><div class="eb-panel"><p class="eb-error">Could not load Early Buy catalog fixture.</p><p>' +
        esc(err.message || String(err)) +
        "</p></div></div>";
    });
})();
